import { render, staticRenderFns } from "./PropPopup.vue?vue&type=template&id=dd94dc9c&scoped=true&"
import script from "./PropPopup.vue?vue&type=script&lang=js&"
export * from "./PropPopup.vue?vue&type=script&lang=js&"
import style0 from "./PropPopup.vue?vue&type=style&index=0&id=dd94dc9c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd94dc9c",
  null
  
)

export default component.exports